import Toast from "./Toast";
import useToasts, { Toast as ToastType } from "./useToasts";
import { Button } from "@ui";
import { faQuestion } from "@fortawesome/free-solid-svg-icons";
import { useCallback, useState } from "react";
import { useApi } from "@hooks/useApi";
import { useTranslation } from "react-i18next";

interface Props {
    toast: ToastType;
}

const ConfirmationToast = ({ toast }: Props) => {
    const { t } = useTranslation("common");
    const api = useApi();
    const { removeToast } = useToasts();
    const { id, title, description, data } = toast;
    const [isLoading, setIsLoading] = useState(false);

    const handleConfirmation = useCallback(() => {
        setIsLoading(true);
        void api({
            url: data?.confirmation_url,
            method: data?.request.method,
            data: data?.request.data,
            headers: data?.request.headers,
            toastCallback: toast.callback,
            onFailure: () => setIsLoading(false),
            onSuccess: () => {
                toast.callback?.();
                removeToast(id);
            }
        });
    }, [toast]);

    return <Toast toastId={id}
        title={title}
        icon={faQuestion}
        description={description}
        content={<div className="tw-flex tw-gap-4 tw-justify-between">
            <Button size="xs" block auto color="error" onPress={() => removeToast(id)} isLoading={isLoading}
            >{t("actions.cancel")}</Button>
            <Button size="xs" block auto onPress={handleConfirmation} isLoading={isLoading}>{t("actions.confirm")}</Button>
        </div>}
    />;
};

export default ConfirmationToast;
